import React from 'react';

// Approximate SVG coordinates for major German cities (viewBox 0-440 x 0-460)
const CITY_COORDS = {
  // Schleswig-Holstein
  'kiel': { x: 215, y: 35 },
  'lübeck': { x: 228, y: 50 },
  'flensburg': { x: 198, y: 15 },
  // Hamburg
  'hamburg': { x: 215, y: 78 },
  // Mecklenburg-Vorpommern
  'rostock': { x: 278, y: 38 },
  'schwerin': { x: 252, y: 62 },
  'stralsund': { x: 305, y: 30 },
  'greifswald': { x: 318, y: 35 },
  'neubrandenburg': { x: 305, y: 65 },
  // Niedersachsen
  'hannover': { x: 210, y: 125 },
  'braunschweig': { x: 240, y: 125 },
  'osnabrück': { x: 160, y: 128 },
  'oldenburg': { x: 160, y: 100 },
  'wolfsburg': { x: 248, y: 115 },
  'göttingen': { x: 215, y: 160 },
  'hildesheim': { x: 218, y: 138 },
  'salzgitter': { x: 233, y: 132 },
  'lüneburg': { x: 228, y: 92 },
  'emden': { x: 132, y: 90 },
  'celle': { x: 222, y: 115 },
  'melle-kerßenbrock': { x: 165, y: 132 },
  'melle': { x: 165, y: 132 },
  // Bremen
  'bremen': { x: 175, y: 100 },
  'bremerhaven': { x: 170, y: 82 },
  // Brandenburg
  'potsdam': { x: 315, y: 140 },
  'cottbus': { x: 345, y: 175 },
  'frankfurt (oder)': { x: 355, y: 150 },
  // Berlin
  'berlin': { x: 330, y: 130 },
  // Sachsen-Anhalt
  'magdeburg': { x: 265, y: 145 },
  'halle': { x: 270, y: 175 },
  'dessau': { x: 278, y: 160 },
  // Nordrhein-Westfalen
  'düsseldorf': { x: 108, y: 195 },
  'köln': { x: 108, y: 210 },
  'dortmund': { x: 138, y: 190 },
  'essen': { x: 122, y: 190 },
  'duisburg': { x: 112, y: 188 },
  'bochum': { x: 130, y: 192 },
  'wuppertal': { x: 122, y: 200 },
  'bielefeld': { x: 162, y: 168 },
  'bonn': { x: 108, y: 225 },
  'münster': { x: 140, y: 162 },
  'krefeld': { x: 105, y: 192 },
  'aachen': { x: 85, y: 215 },
  'paderborn': { x: 170, y: 175 },
  'haltern am see': { x: 130, y: 178 },
  'willich': { x: 108, y: 190 },
  // Hessen
  'frankfurt am main': { x: 170, y: 258 },
  'frankfurt': { x: 170, y: 258 },
  'wiesbaden': { x: 160, y: 255 },
  'kassel': { x: 198, y: 195 },
  'darmstadt': { x: 168, y: 270 },
  'offenbach': { x: 174, y: 262 },
  'marburg': { x: 180, y: 225 },
  'gießen': { x: 178, y: 235 },
  'fulda': { x: 210, y: 240 },
  'dautphetal': { x: 176, y: 228 },
  // Thüringen
  'erfurt': { x: 252, y: 228 },
  'jena': { x: 264, y: 235 },
  'gera': { x: 278, y: 238 },
  'weimar': { x: 258, y: 230 },
  'eisenach': { x: 232, y: 225 },
  // Sachsen
  'dresden': { x: 335, y: 222 },
  'leipzig': { x: 290, y: 195 },
  'chemnitz': { x: 310, y: 230 },
  'zwickau': { x: 298, y: 238 },
  'eilenburg': { x: 298, y: 195 },
  // Rheinland-Pfalz
  'mainz': { x: 158, y: 262 },
  'ludwigshafen': { x: 158, y: 272 },
  'koblenz': { x: 128, y: 245 },
  'trier': { x: 98, y: 270 },
  'kaiserslautern': { x: 140, y: 288 },
  // Saarland
  'saarbrücken': { x: 108, y: 318 },
  // Baden-Württemberg
  'stuttgart': { x: 185, y: 348 },
  'mannheim': { x: 162, y: 288 },
  'karlsruhe': { x: 162, y: 308 },
  'freiburg': { x: 148, y: 380 },
  'heidelberg': { x: 164, y: 292 },
  'ulm': { x: 215, y: 358 },
  'heilbronn': { x: 188, y: 320 },
  'pforzheim': { x: 172, y: 322 },
  'reutlingen': { x: 195, y: 360 },
  'tübingen': { x: 192, y: 362 },
  'konstanz': { x: 188, y: 405 },
  'ettenheim': { x: 148, y: 365 },
  'donzdorf': { x: 205, y: 350 },
  // Bayern
  'münchen': { x: 262, y: 378 },
  'nürnberg': { x: 258, y: 318 },
  'augsburg': { x: 244, y: 365 },
  'regensburg': { x: 282, y: 330 },
  'würzburg': { x: 218, y: 278 },
  'ingolstadt': { x: 260, y: 348 },
  'fürth': { x: 255, y: 316 },
  'erlangen': { x: 252, y: 310 },
  'bamberg': { x: 248, y: 290 },
  'bayreuth': { x: 268, y: 286 },
  'passau': { x: 318, y: 358 },
  'rosenheim': { x: 278, y: 395 },
  'schwaig bei nürnberg': { x: 262, y: 320 },
  'schwaig': { x: 262, y: 320 },
  'unterschleißheim': { x: 258, y: 372 },
};

// Bundesland center coords as fallback
const BUNDESLAND_COORDS = {
  'schleswig-holstein': { x: 210, y: 45 },
  'hamburg': { x: 215, y: 78 },
  'mecklenburg-vorpommern': { x: 295, y: 55 },
  'niedersachsen': { x: 185, y: 130 },
  'bremen': { x: 175, y: 100 },
  'brandenburg': { x: 320, y: 145 },
  'berlin': { x: 330, y: 130 },
  'sachsen-anhalt': { x: 275, y: 165 },
  'nordrhein-westfalen': { x: 125, y: 195 },
  'hessen': { x: 180, y: 255 },
  'thüringen': { x: 260, y: 235 },
  'sachsen': { x: 320, y: 225 },
  'rheinland-pfalz': { x: 125, y: 280 },
  'saarland': { x: 108, y: 318 },
  'baden-württemberg': { x: 175, y: 360 },
  'bayern': { x: 270, y: 360 },
};

// Germany outline
const GERMANY_PATH = `M 200,10 L 215,12 225,18 240,15 258,20 275,12 290,18 310,25 330,22 345,35 355,50 360,70 355,85 345,95 340,110 345,130 350,145 355,160 365,170 370,185 365,200 358,215 350,228 340,238 335,252 340,268 348,280 345,295 335,310 325,325 328,340 335,355 340,365 338,380 330,395 318,405 305,415 290,420 275,430 260,440 245,445 230,448 215,445 200,440 185,435 170,440 155,445 140,438 128,425 118,410 108,395 95,385 85,370 82,355 88,340 95,325 98,310 92,295 88,280 82,265 78,250 82,240 92,230 98,218 108,205 118,195 115,180 108,165 100,150 108,138 118,128 128,115 135,100 145,90 155,75 160,60 168,48 178,35 188,22 200,10`;

function getCityCoords(city, bundesland) {
  const norm = (s) => s.toLowerCase().replace(/ü/g, 'u').replace(/ö/g, 'o').replace(/ä/g, 'a').replace(/ß/g, 'ss').trim();
  const cityNorm = norm(city);
  
  // Direct city match
  if (CITY_COORDS[cityNorm]) return CITY_COORDS[cityNorm];
  
  // Partial match
  for (const [key, coords] of Object.entries(CITY_COORDS)) {
    if (cityNorm.includes(key) || key.includes(cityNorm)) return coords;
  }
  
  // Fallback to Bundesland center with small random offset
  const blNorm = norm(bundesland);
  const bl = BUNDESLAND_COORDS[blNorm];
  if (bl) {
    // Deterministic offset based on city name to avoid overlap
    let hash = 0;
    for (let i = 0; i < city.length; i++) hash = ((hash << 5) - hash + city.charCodeAt(i)) | 0;
    const ox = ((hash % 20) - 10);
    const oy = (((hash >> 4) % 20) - 10);
    return { x: bl.x + ox, y: bl.y + oy };
  }
  return null;
}

const STATUS_COLORS = {
  lead_generated: '#6366f1',
  contacted: '#10b981',
  no_interest: '#ef4444',
  follow_up: '#f59e0b',
};

export function GermanyMap({ cityPoints = [], bundeslandData = [], className = '' }) {
  const resolvedPoints = cityPoints
    .map(p => {
      const coords = getCityCoords(p.city, p.bundesland);
      return coords ? { ...p, ...coords } : null;
    })
    .filter(Boolean);

  return (
    <svg viewBox="0 0 440 460" className={className} xmlns="http://www.w3.org/2000/svg">
      {/* Germany outline */}
      <path
        d={GERMANY_PATH}
        fill="#f8fafc"
        stroke="#cbd5e1"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      
      {/* Inactive Bundesland center markers (light grey) */}
      {Object.entries(BUNDESLAND_COORDS).map(([name, coords]) => (
        <circle
          key={`bl-${name}`}
          cx={coords.x}
          cy={coords.y}
          r={3}
          fill="#e2e8f0"
          stroke="#cbd5e1"
          strokeWidth="0.5"
        />
      ))}

      {/* Active city dots — red/colored based on status */}
      {resolvedPoints.map((point, i) => {
        const color = STATUS_COLORS[point.status] || '#ef4444';
        return (
          <g key={`point-${i}`}>
            {/* Glow effect */}
            <circle cx={point.x} cy={point.y} r={14} fill={color} opacity={0.12} />
            <circle cx={point.x} cy={point.y} r={9} fill={color} opacity={0.25} />
            {/* Main dot */}
            <circle cx={point.x} cy={point.y} r={5.5} fill={color} stroke="white" strokeWidth="1.5" />
          </g>
        );
      })}

      {/* City labels for active points */}
      {resolvedPoints.map((point, i) => (
        <text
          key={`label-${i}`}
          x={point.x}
          y={point.y + 16}
          textAnchor="middle"
          fill="#334155"
          fontSize="8"
          fontWeight="500"
        >
          {point.city.length > 16 ? point.city.substring(0, 14) + '…' : point.city}
        </text>
      ))}
    </svg>
  );
}
